import { createSelector } from "reselect";
import { FlyerDetailPageState } from "../../../types/flyer-detail-page-state/flyer-detail-page-state.interface";
import { getFlyerDetailPageState } from "../../../store/flyer-detail-page.store";
import Store from "../../../../../../../../../redux/store";
import * as actions from "../store/flyer-detail-page-assets.actions";
import { IAsset } from "../../../../../../../../../features/file-attachments/types/file-attachment.interface";
import { FlyerDetailPageAssetsState } from "../types/flyer-detail-page-assets.interface";

export const getFlyerDetailPageAssetsState = createSelector(
  getFlyerDetailPageState,
  (state?: FlyerDetailPageState) => state?.flyerDetailPageAssetsState
);

export const getPageAssets = createSelector(
  getFlyerDetailPageAssetsState,
  (state?: FlyerDetailPageAssetsState) => state?.assets || null
);

export const isLoading = createSelector(
  getFlyerDetailPageAssetsState,
  (state?: FlyerDetailPageAssetsState) => !!state?.isLoading
);

export function fetchPageAssets(pageId: number) {
  Store.dispatch(actions.fetchPageAssets(pageId));
}

export function uploadPageAssets(files: File[]) {
  Store.dispatch(actions.uploadPageAssets(files));
}

export function setPageAssets(assets: IAsset[]) {
  Store.dispatch(actions.setPageAssets(assets));
}
